import { RawDraftContentState } from 'draft-js';

export const removeInlineLinkFromBody = (
  body: RawDraftContentState,
  entityKey: string,
): RawDraftContentState => {
  const entityKeyNum = Number(entityKey);

  return {
    entityMap: Object.fromEntries(
      Object.entries(body.entityMap ?? {}).filter(([key]) => key !== entityKey),
    ),
    blocks: body.blocks.map((block) => ({
      ...block,
      entityRanges: (block.entityRanges ?? []).filter(
        (range) => range.key !== entityKeyNum,
      ),
    })),
  };
};
